import React from 'react';
import { Box, Flex } from '@chakra-ui/react';
import ReviewerSearchConfigure from '../ReviewerSearch';
import BoardMembersSection from '../BoardMembersSection';

interface ReviewerSearchProps {
  journalId: string;
  reviewerSearch?: boolean;
  createAccount?: boolean;
  lexiconClassId?: string;
  lexiconProjectId?: string;
  globalReviewerSearchEnabled?: boolean;
  isBoardMemberReviewerAssignmentEnabled?: boolean;
  journalName: string;
  organizationId: string;
}

const ReviewerSearchTab: React.FC<ReviewerSearchProps> = ({
  journalId,
  reviewerSearch,
  createAccount,
  lexiconClassId,
  lexiconProjectId,
  globalReviewerSearchEnabled,
  isBoardMemberReviewerAssignmentEnabled,
  journalName,
  organizationId
}) => {
  return (
    <Flex flexDirection="column" gap={4} width={'100%'}>
      <ReviewerSearchConfigure
        journalId={journalId}
        reviewerSearch={reviewerSearch}
        createAccount={createAccount}
        lexiconClassId={lexiconClassId}
        lexiconProjectId={lexiconProjectId}
        globalReviewerSearch={globalReviewerSearchEnabled}
      />                                     

      <Box id="board-members">
        <BoardMembersSection
          journalId={journalId}
          organizationId={organizationId}
          journalName={journalName}
          isBoardMemberReviewerAssignmentEnabled={
            isBoardMemberReviewerAssignmentEnabled                  
          }
        />      
      </Box>
    </Flex>
  );
};

export default React.memo(ReviewerSearchTab);
